export type creditCardInfoErrors = {
	firstName: boolean;
	lastName: boolean;
	expirationMonth: boolean;
	expirationYear: boolean;
	cardExpired: boolean;
};

export const creditCardInfoErrorsDefault = {
	firstName: false,
	lastName: false,
	expirationMonth: false,
	expirationYear: false,
	cardExpired: false,
};

type Props = {
	firstName: string;
	lastName: string;
	expirationMonth: string;
	expirationYear: string;
};

const validateCreditCardInfo = ({ firstName, lastName, expirationMonth, expirationYear }: Props) => {
	const errors: creditCardInfoErrors = { ...creditCardInfoErrorsDefault };

	errors.firstName = firstName === '';
	errors.lastName = lastName === '';
	errors.expirationMonth = expirationMonth === '';
	errors.expirationYear = expirationYear === '';

	// Check if a card has expired
	const currentDate = new Date();
	const intExpirationMonth = parseInt(expirationMonth);
	const intExpirationYear = parseInt(expirationYear);
	const expirationDate = new Date(intExpirationYear, intExpirationMonth);
	if (currentDate >= expirationDate) {
		errors.cardExpired = true;
	}

	return errors;
};

export default validateCreditCardInfo;
